module.exports = __webpack_public_path__ + "img/23. Closex.da26e446.svg";